import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { PatientEhrDataFacadeService } from '../../patient-ehr-data-facade.service';
import { getIconByFileType } from '@drl/shared/utility/file-type.utility';
import { fi } from 'date-fns/locale';

@Component({
  selector: 'app-view-upload-pres-docs',
  templateUrl: './view-upload-pres-docs.component.html',
  styleUrls: ['./view-upload-pres-docs.component.scss']
})
export class ViewUploadPresDocsComponent implements OnInit {
  @Input() files: any[] = [];
  loader: boolean = false;
  disableFileTypes = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'];

  constructor(
    protected dialogRef: NbDialogRef<ViewUploadPresDocsComponent>,
    private pehrFacadeService: PatientEhrDataFacadeService,

  ) { }

  ngOnInit() {
  }
  close(refresh: boolean = false) {
    this.dialogRef.close({ refresh: refresh });
  }
  removeFile(file) {
    this.loader = true;
    if (!file || !file.id) {
      console.warn('Invalid file or file ID:', file);
      return;
    }

    this.pehrFacadeService.deletePrescriptionFile(file.id).subscribe({
      next: () => {
        this.files = this.files.filter(f => f.id !== file.id);
        if (this.files.length === 0) {
          this.close(true);
        }
        this.loader = false;
      },
      error: (err) => {
        console.error('Error deleting file:', err);
      }
    });
  }
  async downloadFile(file) {
    if (!file || !file.filePath) {
      console.warn('Invalid file or file path:', file);
      return;
    }

    try {
      const response = await fetch(file.filePath,{mode: 'cors'});
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = file.fileName || 'download';
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  }



  viewFile(file) {
    // Implement file viewing logic here
    // This could involve opening the file in a new tab or using a modal to display the file content  
    if (file && file.filePath) {
      window.open(file.filePath, '_blank');
    }
  }

  getIconByFileType(fileType) {
    return getIconByFileType(fileType);
  }

  // Array of extensions to disable

  isDisabledFile(file: any): boolean {
    if (!file?.filePath) return false;
  
    // Extract file extension from URL
    const url = file.filePath.split('?')[0]; // remove S3 query params
    const ext = url.split('.').pop()?.toLowerCase() || '';
  
    return this.disableFileTypes.includes(ext);
  }
}
